import styled from 'styled-components';

import withConfig from '../../../context/withConfig';
import withIsMobile from '../../../context/withIsMobile';

const getBotAvatar = ({ config, inOperatorConversation }) => {
  if (inOperatorConversation && !!config.images.liveChatAvatar) {
    return config.images.liveChatAvatar;
  }
  return config.images.chatAvatar;
};

const BotAvatar = styled.div`
  margin: ${props => (props.isMobile ? '0 10px' : '0 20px')};
  height: 24px;
  width: 24px;
  background: url("${props => getBotAvatar(props)}") center / 100% no-repeat;
  flex-shrink: 0;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

export default withIsMobile(withConfig(BotAvatar));



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotAvatar/index.js